import type { FetchAIEventsParams } from '../../api/aiEventsApi';

const aiEventsRoot = ['ai-events'] as const;

/**
 * Query key factory for AI events.
 *
 * Usage:
 *   useQuery({ queryKey: aiEventsKeys.list(params), queryFn: () => fetchAIEvents(params) })
 *
 * SSE invalidation:
 *   queryClient.invalidateQueries({ queryKey: aiEventsKeys.all })
 *   → invalidates every ai-events query (all pages / filter combos) at once.
 */
export const aiEventsKeys = {
  all: aiEventsRoot,
  list: (params: FetchAIEventsParams) => [...aiEventsRoot, 'list', params] as const,
} as const;
